import { FetchCredentialingEmailReplies } from '../../constants/api.config'
import getCharts from '../getCharts'

export default async function FetchCredentialingEmailRepliesApi(payload = {}) {
    try {
        const requestPayload = {
            payload,
        }

        const res = await getCharts(FetchCredentialingEmailReplies, requestPayload)
        return res.data
    } catch (error) {
        return error
    }
}
